import styled from 'styled-components';

export const AppContainer = styled.div.attrs(() => ({
  className: `antialiased mx-auto container mx-auto md:max-w-full lg:max-w-screen-xl px-5 md:px-12 lg:px-8`,
}))``;
